import { Component, inject } from '@angular/core';
import { Entity } from '@app/core/model/entities/entity';
import { AssetGroupsService } from '@app/features/main/views/asset-groups/asset-groups.service';
import {
  ServerSideIndicatorStatusPanelComponent
} from '@app/shared/components/indicator-status-panel/server-side-indicator-status-panel/server-side-indicator-status-panel.component';
import { SelectParams } from '@app/shared/grid/datasource-utils';
import { IStatusPanelParams } from 'ag-grid-community';
import { merge, Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';

@Component({
  selector: 'asset-groups-indicator-status-panel',
  templateUrl: '../indicator-status-panel.component.html',
  styleUrls: ['../indicator-status-panel.component.scss'],
  standalone: false
})
export class AssetGroupsIndicatorStatusPanelComponent extends ServerSideIndicatorStatusPanelComponent {
  private assetGroupsService = inject(AssetGroupsService);

  /**
   * Set gridApi and add listen for row updates.
   */
  public agInit(params: IStatusPanelParams<Entity>): void {
    super.agInit(params);

    merge(
      this.assetGroupsService.assetGroupAdded$,
      this.assetGroupsService.assetGroupsDeleted$,
      this.assetGroupsService.assetGroupsUpdated$
    )
      .subscribe(() => this.updateIndicatorsValues());
  }

  /**
   * Get aggregation result.
   * @param selectParams The parameters for the query. These include filtering and aggregating.
   * @return Observable<Entity> Result of the aggregation query.
   */
  protected getAggregationResult(selectParams: SelectParams): Observable<Entity> {
    return this.assetGroupsService.loadAssetGroupsPage(selectParams)
      .pipe(first(), map(assets => assets.first()));
  }
}
